class ProductCarousel extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.slides = this.querySelectorAll('.splide__slide')
    this.showArrows = this.getAttribute('data-show-arrows') === 'true'
    this.slider = this.querySelector('.splide')
    if (this.slides.length >= 2) {
      new Splide(this.slider, {
        interval: 5000,
        arrows: this.showArrows,
        autoWidth: true,
        gap: 12,
        focus: 0,
        omitEnd: true,
        pagination: false,
      }).mount()
    }
  }
}

customElements.define('product-carousel', ProductCarousel)
